import { addEventListener } from '../../utilities/dom'
import './index.css'

export default class Index {
  constructor(options) {
    this.options = options
    this.init()
    this.message = ''
  }

  init() {
    const self = this,
          div  = document.createElement('div'),
          id = this.options.id

    div.id = id
    div.classList.add('bta-bar-message')
    div.innerHTML = `<div id="booking-status"></div><div class="countdown"></div><div class="bta-bar-message-close">&times;</div>`
    div.style.top = `${window.innerHeight}px`
    document.body.append(div)

    this.bar = div
    this.close = document.querySelector(`#${id} .bta-bar-message-close`)
    this.status = document.querySelector(`#${id} #booking-status`)

    addEventListener([this.close], 'click', () => {
      self.hide()
    })
  }

  show() {
    if (this.message) this.bar.style.top = `${window.innerHeight - this.bar.clientHeight}px`
  }

  hide() {
    this.bar.style.top = `${window.innerHeight}px`
    this.options.onHide && this.options.onHide()
  }

  showInfo(message) {
    this.message = message
    this.bar.querySelector('#booking-status').innerHTML = message
  }

  updateCountDown(message) {
    this.bar.querySelector('.countdown').innerHTML = message
  }
}
